export default {
  patient: {
    ipp: 20,
    nom: 40,
    nomnaissance: 40,
    naissancedate: 40,
    adresse1: 40,
    cpost: 40,
    tel: 20,
    nopatlabo: 40,
    numhosp: 20,
    prenom: 40,
    lieunaissance: 40,
    nomjf: 40,
    adresse2: 40,
    ville: 40,
    ins: 15
  },
  profile: {
    code: 10,
    label: 40,
    examenacces: 1,
    elementacces: 1,
    bannerrefresh: 3,
    monitoring: 3,
    nbdem: 2,
    choixuf: 1,
    bacterio: 1,
    visibilite: 1

  },
  actor: {
    code: 10,
    actorname: 40,
    address: 40,
    postalcode: 40,
    town: 40,
    tel: 40,
  },
  user: {
    tel: 20,
    web: 20,
    ftp: 20,
    clef: 40,
    fax: 40,
    mail: 40,
    printer: 40,
    ipp: 40,
    nom: 40,
    naissancedate: 40,
    adresse1: 40,
    cpost: 40,
    nopatlabo: 40,
    numhosp: 40,
    firstname: 40,
    lieunaissance: 40,
    name: 40,
    adresse2: 40,
    ville: 40,
    logincode: 25,
    password: 64

  },
  account: {
    tel: 20,
    web: 20,
    ftp: 20,
    clef: 40,
    fax: 40,
    mail: 40,
    printer: 40,

  },
  delegation: {},
  association: {},
  group: {
    name : 25
  },
  dictionary: {
    code: 10,
    label: 40,
    accessLevel: 1,
  },
  consultationHistory: {
    ipp: 20,
    demandNumber: 20,
    name: 40,
    logincode: 25,
  },
  settings: {
    demand: {
      demande_v: 200,
      demande_b: 200,
      demande_a: 200,
      libelle_valid_par: 50
    }
  },
  fusion: {
    name: 40
  }

};